import { Breadcrumb as ChakraBreadcrumb, BreadcrumbItem, BreadcrumbLink, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

const Breadcrumb = ({ crumbs, count }: { crumbs: Crumb[]; count?: number }) => (
  <ChakraBreadcrumb
    fontSize="13px"
    color="rs.textMuted"
    separator="/"
    mb={6}
  >
    <BreadcrumbItem>
      <BreadcrumbLink as={RouterLink} to="/" color="rs.textMuted" _hover={{ color: "rs.text" }}>
        Home
      </BreadcrumbLink>
    </BreadcrumbItem>
    {crumbs.map((crumb, i) => (
      <BreadcrumbItem key={i} isCurrentPage={i === crumbs.length - 1}>
        {crumb.to ? (
          <BreadcrumbLink
            as={RouterLink}
            to={crumb.to}
            color="rs.textMuted"
            _hover={{ color: "rs.text" }}
          >
            {crumb.label}
          </BreadcrumbLink>
        ) : (
          <Text as="span" color="rs.text">
            {crumb.label}
            {typeof count === "number" && ` — ${count} items`}
          </Text>
        )}
      </BreadcrumbItem>
    ))}
  </ChakraBreadcrumb>
);

export default Breadcrumb;
